/*
 * Revival customer type ("I'm a dog breeder / cat breeder / shelter / equine / vet").
 * Stored per visitor (localStorage + cookie so Liquid/apps could read it later).
 * Sets <html data-customer-type="..."> and fires "revival:customer-type" so sections can react.
 * A logged-in customer's type (from Liquid, window.RevivalCustomerType) is the default.
 * The chosen type is also recorded:
 *   - on the cart as the attribute "Customer type", so it lands on the order (Additional details) and can be
 *     tagged by Shopify Flow. Written when the type changes, on page load and after cart changes, once per cart.
 *   - on the visitor's Klaviyo profile as site_customer_type (for visitors Klaviyo can identify). This is a
 *     self-selected browsing signal kept separate from the team's own classification fields.
 */
(function () {
  var KEY = 'revival_ct';
  var TYPES = ['dog-breeder', 'cat-breeder', 'shelter', 'equine', 'vet'];
  var LABELS = { 'dog-breeder': 'Dog Breeder', 'cat-breeder': 'Cat Breeder', shelter: 'Shelter or Rescue', equine: 'Equine', vet: 'Vet Clinic' };
  var ATTR = 'Customer type';
  var CART_KEY = 'revival_ct_cart';
  var KL_KEY = 'revival_ct_klaviyo';

  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function cartToken() {
    var m = document.cookie.match(/(?:^|; )cart=([^;]+)/);
    return m ? m[1] : '';
  }
  // Write the type to the cart once per cart and type. Skips when there is no cart yet (the cart-change listener
  // catches the first add) and when the visitor never chose a type and the cart has none to clear.
  function syncCart(type, force) {
    var token = cartToken();
    if (!token) return;
    var key = (type || 'none') + '|' + token;
    var last = ss(CART_KEY);
    if (!force && last === key) return;
    if (!type && !last) return;
    var attrs = {}; attrs[ATTR] = type ? LABELS[type] : '';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (r.ok) ss(CART_KEY, key); }).catch(function () {});
  }
  // Save the type on the Klaviyo profile (once per session per type). Uses the current Klaviyo object when present,
  // otherwise the legacy _learnq queue, which Klaviyo replays when it loads.
  function syncKlaviyo(type, force) {
    if (!type) return;
    if (!force && ss(KL_KEY) === type) return;
    var props = { site_customer_type: LABELS[type], site_customer_type_updated: new Date().toISOString().slice(0, 10) };
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify(props);
      else (window._learnq = window._learnq || []).push(['identify', props]);
      ss(KL_KEY, type);
    } catch (e) {}
  }

  function read() {
    try { var v = localStorage.getItem(KEY); if (TYPES.indexOf(v) > -1) return v; } catch (e) {}
    var m = document.cookie.match(/(?:^|; )revival_ct=([^;]+)/);
    if (m && TYPES.indexOf(m[1]) > -1) return m[1];
    if (window.RevivalCustomerType && TYPES.indexOf(window.RevivalCustomerType) > -1) return window.RevivalCustomerType;
    return '';
  }

  function apply(type) {
    var root = document.documentElement;
    if (type) root.setAttribute('data-customer-type', type); else root.removeAttribute('data-customer-type');
    document.querySelectorAll('[data-ct-option]').forEach(function (el) {
      var on = el.getAttribute('data-ct-option') === type;
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.dispatchEvent(new CustomEvent('revival:customer-type', { detail: { type: type } }));
  }

  function set(type) {
    if (type && TYPES.indexOf(type) === -1) return;
    try { type ? localStorage.setItem(KEY, type) : localStorage.removeItem(KEY); } catch (e) {}
    document.cookie = KEY + '=' + (type || '') + '; path=/; max-age=' + (type ? 31536000 : 0) + '; SameSite=Lax';
    apply(type);
    syncCart(type, true);
    syncKlaviyo(type, true);
  }

  window.RevivalCT = { get: read, set: set, types: TYPES };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ct-option]');
    if (!btn) return;
    e.preventDefault();
    var t = btn.getAttribute('data-ct-option');
    set(read() === t ? '' : t);
  });

  apply(read());
  document.addEventListener('DOMContentLoaded', function () {
    apply(read());
    // Record a stored or account-based type without slowing the page.
    setTimeout(function () { var t = read(); syncCart(t); syncKlaviyo(t); }, 1500);
  });
  // A cart created or changed after the type was chosen (first add to cart, quick add, cart drawer edits).
  document.addEventListener('shopify:cart:lines-update', function () { syncCart(read()); });
  document.addEventListener('shopify:section:load', function () { apply(read()); });
})();
